class ProjectBadge
  options:
    autoSave: false
    syncValue: true

  constructor: (options) ->
    @options = $.extend({}, @options, options)
    @_bind()

  _bind: ->
    return unless @options.target
    if @options.targetParent
      $(@options.targetParent).on('click', @options.target, @_showBadgeSetting)
    else
      $(@options.target).on 'click', @_showBadgeSetting

  _showBadgeSetting: (e) =>
    $target = $(e.target)
    $panel = $ $('#tpl-project-badge').html()
    $project = $target.closest('.project')
    curColor = $project.attr('class').match(/c\d+/)[0]
    curIcon = $project.attr('class').match(/i\d+/)[0]

    $panel.find("li.#{curColor}").addClass('selected')
    $panel.find('.icons li').addClass(curColor)
      .filter(".#{curIcon}").addClass 'selected'

    @popover = simple.popover
      pointTo: $target
      content: $panel
      position: 'bottom-center'

    @popover.el.on 'click', '.color-sets li', @_selectBadgeColor
    @popover.el.on 'click', '.icons li', @_selectBadgeIcon
    return false


  _selectBadgeColor: (e) =>
    $target = $(e.currentTarget)
    cls = $target.attr('class')

    $target.addClass('selected').siblings('.selected').removeClass('selected')

    @popover.el.find('.icons li').each ->
      newCls = $(@).attr('class').replace(/c\d+/, cls)
      $(@).attr 'class', newCls

    $project = @popover.pointTo.closest('.project')

    $project.attr 'class', $project.attr('class').replace(/c\d+/, cls)
    @_syncValue $project
    @_saveBadge $project

    return false


  _selectBadgeIcon: (e) =>
    $target = $(e.currentTarget)

    cls = $target.attr('class').match(/i\d+/)[0]
    $target.addClass('selected').siblings('.selected').removeClass('selected')

    $project = @popover.pointTo.closest('.project')

    $project.attr 'class', $project.attr('class').replace(/i\d+/, cls)
    @_syncValue $project
    @_saveBadge $project

    return false


  _syncValue: ($project) =>
    return unless @options.syncValue
    $('input#color_id').val $project.attr('class').match(/c(\d+)/)[1] - 1
    $('input#icon_id').val $project.attr('class').match(/i(\d+)/)[1] - 1


  _saveBadge: ($project) =>
    return unless @options.autoSave

    $.ajax
      url: "/projects/#{$project.data('guid')}/badge"
      type: 'post'
      dataType: 'json'
      data:
        color_id: $project.attr('class').match(/c(\d+)/)[1] - 1
        icon_id: $project.attr('class').match(/i(\d+)/)[1] - 1


tower.projectBadge = (options) ->
  new ProjectBadge(options)

